import ImageRepository from "../repositories/ImageRepository";
import { buildSearchParams } from "../utils/requestHelpers";

//401/403 on images means the user has no Document Power access in McLeod
const flagDocumentPowerDenied = error => Promise.reject(
  [401, 403].includes(error?.status) ? { ...error, documentPowerDenied: true } : error
);

export class ImageService {
  static GetDocumentTypes(instance, type, id) {
    const repo = new ImageRepository;
    const params = buildSearchParams(
      {
        rowType: type,
        rowId: id
      }
    );

    return repo.getDocumentsTypes(instance, params).catch(flagDocumentPowerDenied);
  }

  static GetDocument(instance, type, id) {
    const repo = new ImageRepository;
    const params = buildSearchParams(
      {
        documentType: type,
        id: id
      }
    );

    return repo.getDocument(instance, id, params).catch(flagDocumentPowerDenied);
  }
  
  static GetDocuments(instance, type, id) {
    const repo = new ImageRepository;
    const params = buildSearchParams(
      {
        rowType: type,
        rowId: id
      }
    );

    return repo.getDocuments(instance, params).catch(flagDocumentPowerDenied);
  }

  static UploadDocument(instance, payload) {
    const repo = new ImageRepository;

    return repo.uploadDocument(instance, payload).catch(flagDocumentPowerDenied);
  }
}